import React, { useEffect, useState } from "react";
import "./changePassword.scss";
import { changePassword } from "services/user/userService";
import Swal from "sweetalert2";
import { PacmanLoader } from "react-spinners";

const ChangePassword = () => {
  const token = localStorage.getItem("token");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);


  const handlePassword = async () => {
    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Cập nhật thất bại!",
        text: "Mật khẩu mới không trùng nhau",
        confirmButtonColor: "#5e2e86",
      });
      return;
    }

    if (!oldPassword) {
      Swal.fire({
        icon: "error",
        title: "Cập nhật thất bại!",
        text: "Bạn chưa nhập mật khẩu cũ",
        confirmButtonColor: "#5e2e86",
      });
      return;
    }
    try {
      setIsLoading(true);

      const response = await changePassword(token, oldPassword, newPassword);
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Đổi mật khẩu thành công!",
          // text: "Địa chỉ của bạn đã được lưu.",
          confirmButtonColor: "#5e2e86", // Tùy chỉnh màu nút
        });
      }
      setOldPassword("")
      setConfirmPassword("")
      setNewPassword("")
    } catch (error) {
      console.error("Có lỗi xảy ra khi thay đổi mật khẩu:", error);
      // alert("Đã có lỗi xảy ra, vui lòng thử lại.");
      if(error.status === 400){
        Swal.fire({
          icon: "error",
          title: "Mật khẩu cũ không đúng!",
          // text: "Địa chỉ của bạn đã được lưu.",
          confirmButtonColor: "#5e2e86", // Tùy chỉnh màu nút
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="change-password-container">
      <div className="card border-0 p-4 mt-5">
        {/* Phần form đổi mật khẩu */}
        <form className="password-form">
          <h3 className="title-list-address">Đổi mật khẩu</h3>
          <div>
            <label htmlFor="old-password">Mật khẩu cũ:</label>
            <input
              id="old-password"
              type="password"
              value={oldPassword} // Thêm giá trị state nếu cần
              onChange={(e) => setOldPassword(e.target.value)} // Hàm xử lý nếu có
            />
          </div>

          <div>
            <label htmlFor="new-password">Mật khẩu mới:</label>
            <input
              id="new-password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>

          <div>
            <label htmlFor="confirm-password">Xác nhận mật khẩu mới:</label>
            <input
              id="confirm-password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          <button
            type="button"
            className="submit-button"
            onClick={handlePassword}
          >
            Đổi mật khẩu
          </button>
        </form>
      </div>
      {isLoading && (
        <div className="modal">
          <div className="overlay_loading">
            <div className="modal-content_loading">
              <div className="d-flex">
                <PacmanLoader color="#5e2e86" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChangePassword;
